import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ConversationItem,
  ConfirmDialogData
} from '@cpd-app/core-module/models';
import { ConfirmDialogComponent } from '@cpd-app/shared-module/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'cpd-conversation-card',
  templateUrl: './conversation-card.component.html',
  styleUrls: ['./conversation-card.component.scss']
})
export class ConversationCardComponent {
  @Input() public conversation: ConversationItem;
  @Input() public expanded = false;
  @Output() public deleteConversation = new EventEmitter<number>();

  public today = new Date().toISOString().split('T')[0];

  constructor(private dialog: MatDialog) {}

  public onDeleteConversation(event: Event): void {
    event.stopPropagation();

    this.dialog.open<any, ConfirmDialogData>(ConfirmDialogComponent, {
      data: {
        confirmText: 'Delete',
        cancelText: 'Cancel',
        title: 'Delete this conversation?',
        icon: 'delete',
        confirmFn: () => {
          this.deleteConversation.emit(this.conversation.id);
        }
      }
    });
  }
}
